import React from "react";
import { MessageCircle, Languages } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { SUPPORT } from "../../lib/site";

export default function Support() {
  return (
    <Section id="support" bg="bg-white">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#0B31EB">Support & Access</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          This Is More Than 20+ Videos Inside an LMS
        </h2>
        <p className="text-base sm:text-lg text-brand-ink/75 mt-5">
          It is a 12-month learning and implementation journey with live guidance, feedback, resources, and community support.
        </p>
      </Reveal>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-brand-black/10 border-2 border-brand-black rounded-[28px] overflow-hidden mt-12">
        {SUPPORT.map((s, i) => (
          <Reveal key={s.t} delay={(i % 4) * 0.05}>
            <div className="bg-brand-cream h-full p-6 sm:p-8 flex flex-col justify-between min-h-[150px] hover:bg-brand-paleyellow transition-colors">
              <span className="font-display text-4xl sm:text-6xl leading-none" style={{ color: i % 2 === 0 ? "#0B31EB" : "#E90019" }}>{s.big}</span>
              <p className="font-semibold text-sm sm:text-base mt-4 leading-tight">{s.t}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-5 mt-6">
        <Reveal>
          <div className="rounded-[24px] border-2 border-brand-black bg-brand-blue text-white p-6 flex items-start gap-4" style={{ boxShadow: "6px 8px 0 #111111" }}>
            <span className="h-11 w-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0"><MessageCircle size={20} /></span>
            <div>
              <p className="font-bold text-lg">Detailed Support</p>
              <p className="text-sm text-white/80 mt-1">WhatsApp, community, live calls, or Loom-style responses when appropriate.</p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="rounded-[24px] border-2 border-brand-black bg-brand-yellow p-6 flex items-start gap-4" style={{ boxShadow: "6px 8px 0 #111111" }}>
            <span className="h-11 w-11 rounded-xl bg-brand-black flex items-center justify-center shrink-0"><Languages size={20} className="text-brand-yellow" /></span>
            <div>
              <p className="font-bold text-lg">Hinglish Teaching</p>
              <p className="text-sm text-brand-ink/75 mt-1">Taught in a clear Hindi and English mix so nothing gets lost in translation.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
